import { createContext, useState } from "react";

const PortfolioContext = createContext();

const AppContext = ({ children }) => {
	const [enterHero, setEnterHero] = useState(false);
	const [enterAboutMe, setEnterAboutMe] = useState(false);
	const [enterProjects, setEnterProjects] = useState(false);
	const [enterFooter, setEnterFooter] = useState(false);
	const [mousePosition, setMousePosition] = useState({
		x: 0,
		y: 0,
		backgroundColor: "#000",
	});
	const [cursorLabel, setCursorLabel] = useState("");

	const value = {
		enterHero,
		setEnterHero,
		mousePosition,
		setMousePosition,
		enterAboutMe,
		setEnterAboutMe,
		enterProjects,
		setEnterProjects,
		enterFooter,
		setEnterFooter,
		cursorLabel,
		setCursorLabel,
	};

	return (
		<PortfolioContext.Provider value={value}>
			{children}
		</PortfolioContext.Provider>
	);
};

export { PortfolioContext };
export default AppContext;
